import React, { useState } from "react";
import PropTypes from "prop-types";

import Menu from "@mui/material/Menu";
import Button from "@mui/material//Button";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles({
  button: {
    width: "100%",
    maxHeight: 30,
    borderRadius: 30,
    textTransform: "none",
    whiteSpace: "nowrap",
    display: "inline-block",
    fontSize: 13,
    overflow: "hidden",
    textOverflow: "ellipsis",
    "&:hover": {
      boxShadow:
        "0px 5px 20px 0px rgba(0, 0, 0, 0.15), 0px 5px 10px -5px rgba(33, 33, 33, 0.5)"
    }
  },
  menuItem: {
    fontSize: 13,
    display: "block",
    lineHeight: 0.5
  },
  caseStatusFieldsWrapper: {
    padding: 10,
    backgroundColor: "#F4F4F4"
  }
});

export function CustomStatusDropdownV2(props) {
  const {
    headerText,
    buttonText,
    dropdownList,
    onMenuItemClicked,
    buttonProps,
    dataQa
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);

  const classes = useStyles();

  const handleClick = ({ currentTarget }) => setAnchorEl(currentTarget);

  const handleClose = () => setAnchorEl(null);

  const handleCloseMenu = (_event, param) => {
    setAnchorEl(null);
    onMenuItemClicked(param);
  };

  const open = Boolean(anchorEl);
  const anchorOrigin = { vertical: "bottom", horizontal: "center" };
  const transformOrigin = { vertical: "top", horizontal: "center" };

  return (
    <div className={classes.caseStatusFieldsWrapper}>
      <Typography variant="h5" align="center">
        {headerText}
      </Typography>
      <Button
        id="case-status-field-button"
        aria-haspopup="true"
        onClick={handleClick}
        className={classes.button}
        aria-controls="case-status-field-menu"
        data-qa={dataQa}
        aria-expanded={open ? "true" : undefined}
        {...buttonProps}
      >
        {buttonText}
      </Button>
      <Menu
        open={open}
        id="case-status-field-menu"
        anchorEl={anchorEl}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        MenuListProps={{
          "aria-labelledby": "case-status-field-button",
          style: {
            backgroundColor: "#F2F4F5"
          }
        }}
      >
        <div className={classes.menuList}>
          {dropdownList &&
            dropdownList.map((item, index) => {
              return (
                <MenuItem
                  key={index}
                  className={classes.menuItem}
                  onClick={_event => handleCloseMenu(_event, item)}
                  style={{ color: item.color }}
                >
                  {item.name}
                </MenuItem>
              );
            })}
        </div>
      </Menu>
    </div>
  );
}

CustomStatusDropdownV2.propTypes = {
  headerText: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  dropdownList: PropTypes.array.isRequired,
  onMenuItemClicked: PropTypes.func.isRequired,
  buttonProps: PropTypes.object.isRequired,
  dataQa: PropTypes.string.isRequired
};
